import React from 'react';
import { useTranslations } from 'use-intl';
import { CheckIcon, CrossIcon, LoaderIcon } from '@mentimeter/ragnar-visuals';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { variants } from './IconContainer.variants';

type Size = 'large' | 'default' | 'compact' | undefined | null;
type State = 'error' | 'success' | 'loading' | undefined | null;

interface IconContainerProps {
  children: React.ReactNode;
  size?: Size;
  state?: State;
}

export const IconContainer = ({
  children,
  size = 'default',
  state,
}: IconContainerProps) => {
  const t = useTranslations('ragnar.button');
  const iconContainerClasses = variants({ size });

  return (
    <span
      className={cn(
        'relative',
        'flex',
        'flex-col',
        'items-start',
        'min-w-0',
        'min-h-0',
        'w-auto',
        iconContainerClasses,
      )}
    >
      {state === 'error' && (
        <CrossIcon
          color="currentColor"
          aria-label={t('button_error_icon_a11y')}
        />
      )}
      {state === 'success' && (
        <CheckIcon
          color="currentColor"
          aria-label={t('button_success_icon_a11y')}
        />
      )}
      {state === 'loading' && (
        <LoaderIcon
          color="currentColor"
          aria-label={t('button_loading_icon_a11y')}
        />
      )}
      {!state && children}
    </span>
  );
};
